import { render, staticRenderFns } from "./registeredAccount.vue?vue&type=template&id=2a8b777a"
import script from "./registeredAccount.vue?vue&type=script&lang=js"
export * from "./registeredAccount.vue?vue&type=script&lang=js"
import style0 from "./registeredAccount.vue?vue&type=style&index=0&id=2a8b777a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports